module.exports = __webpack_public_path__ + "media/images/flags/lc-df36b747305a82f095b632730a75cbad.svg";